<template>
  <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.5 1.33167C0.5 0.5405 1.37525 0.0626581 2.04076 0.490487L6.1915 3.15882C6.80382 3.55246 6.80382 4.44754 6.1915 4.84118L2.04076 7.50951C1.37525 7.93734 0.5 7.4595 0.5 6.66833V1.33167Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "Play"
}
</script>